module.exports = __webpack_public_path__ + "static/avInterior-f6c5d584a9259fc7fc2d8b5c3e6344c4.jpg";